export default __webpack_public_path__ + "static/media/graduation.9bd66d45.svg";